import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import store from '../redux/store'
import { fetchUserAsync } from '../redux/features/user/userSlice'

import { fetchPagesAsync } from '../redux/features/pages/pagesSlice'
import AppRoutes from '../components/AppRoutes'
import { history } from '../router/navigation'
import { clearFlashOnNavigation } from '../router/flashClearing'
import { setFlashNotice, setFlashAlert } from '../redux/features/ui/uiSlice'

// const unsubscribe = store.subscribe(() => console.log(store.getState()))
// store.dispatch(fetchPages()).then(() => console.log(store.getState()))
// unsubscribe()
// store.dispatch(fetchPagesAsync())
clearFlashOnNavigation(store, history)

// Rails' flash from a server redirect (say, Devise's "You need to sign in"),
// which the layout puts in a meta tag as JSON: { notice, alert }. Show it with
// the React flash.
const showServerFlash = () => {
  try {
    const content = document.querySelector('meta[name=server-flash]')?.content
    const flash = content ? JSON.parse(content) : {}
    if (flash.notice) {
      store.dispatch(setFlashNotice(flash.notice))
    }
    if (flash.alert) {
      store.dispatch(setFlashAlert(flash.alert))
    }
  } catch (error) {
    console.error('Could not read the server flash', error)
  }
}
showServerFlash()

store.dispatch(fetchUserAsync())

document.addEventListener('DOMContentLoaded', () => {
  const rootEl = document.body.appendChild(document.createElement('div'))
  const root = createRoot(rootEl)

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <AppRoutes />
      </Provider>
    </React.StrictMode>,
  )
}) 
